// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RangeType } from "./RangeType";
import {
  RangeTypeFromJSON,
  RangeTypeFromJSONTyped,
  RangeTypeToJSON,
  RangeTypeToJSONTyped,
} from "./RangeType";
import type { RasterLayerStyle } from "./RasterLayerStyle";
import {
  RasterLayerStyleFromJSON,
  RasterLayerStyleFromJSONTyped,
  RasterLayerStyleToJSON,
  RasterLayerStyleToJSONTyped,
} from "./RasterLayerStyle";
import type { DType } from "./DType";
import { DTypeFromJSON, DTypeFromJSONTyped, DTypeToJSON, DTypeToJSONTyped } from "./DType";
import type { InternalIds } from "./InternalIds";
import {
  InternalIdsFromJSON,
  InternalIdsFromJSONTyped,
  InternalIdsToJSON,
  InternalIdsToJSONTyped,
} from "./InternalIds";

/**
 *
 * @export
 * @interface RasterLayer
 */
export interface RasterLayer {
  /**
   * The data type of the raster as '{kind}{bytesize}'
   */
  dtype?: DType | null;
  /**
   * The value denoting no data, JSON encoded.
   */
  fillValue?: string | null;
  /**
   *
   */
  rangeType: RangeType;
  /**
   *
   */
  style: RasterLayerStyle;
  /**
   *
   */
  internalIds?: InternalIds | null;
}

/**
 * Check if a given object implements the RasterLayer interface.
 */
export function instanceOfRasterLayer(value: object): value is RasterLayer {
  if (
    (!("rangeType" in (value as Record<string, any>)) &&
      !("range_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["rangeType"] === undefined &&
      (value as Record<string, any>)["range_type"] === undefined)
  )
    return false;
  if (!("style" in value) || value["style"] === undefined) return false;
  return true;
}

export function RasterLayerFromJSON(json: any): RasterLayer {
  return RasterLayerFromJSONTyped(json, false);
}

export function RasterLayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RasterLayer {
  if (json == null) {
    return json;
  }
  return {
    dtype:
      json["dtype"] === undefined
        ? undefined
        : json["dtype"] === null
        ? null
        : DTypeFromJSON(json["dtype"]),
    fillValue:
      json["fill_value"] === undefined
        ? undefined
        : json["fill_value"] === null
        ? null
        : json["fill_value"],
    rangeType: RangeTypeFromJSON(json["range_type"]),
    style: RasterLayerStyleFromJSON(json["style"]),
    internalIds:
      json["internal_ids"] === undefined
        ? undefined
        : json["internal_ids"] === null
        ? null
        : InternalIdsFromJSON(json["internal_ids"]),
  };
}

export function RasterLayerToJSON(json: any): RasterLayer {
  return RasterLayerToJSONTyped(json, false);
}

export function RasterLayerToJSONTyped(
  value?: RasterLayer | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    dtype: DTypeToJSON(value["dtype"]),
    fill_value: value["fillValue"],
    range_type: RangeTypeToJSON(value["rangeType"]),
    style: RasterLayerStyleToJSON(value["style"]),
    internal_ids: InternalIdsToJSON(value["internalIds"]),
  };
}
